import React, { useEffect } from "react";
import "../Blogs/Blogs.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import blog11 from "../../../img/blog11.png";
import blog12 from "../../../img/blog12.jpg";
import blog13 from "../../../img/blog13.jpg";
import blog14 from "../../../img/blog14.jpg";
import blog15 from "../../../img/blog15.jpg";
import blog16 from "../../../img/blog16.jpg";
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from "react-router-dom";

export default function Blogs() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
        <Helmet>
      <title>Blogs | Hearing Loss & Hearing Aids | The Hearing Centre</title>
        <meta name="description" content="At The Hearing Centre we understand the journey of getting used to hearing aids. Go through these blogs by our Audiologists to know more." />
        <meta property="og:title" content="Blogs | Hearing Loss & Hearing Aids | The Hearing Centre"></meta>
        <meta property="og:description" content="At The Hearing Centre we understand the journey of getting used to hearing aids. Go through these blogs by our Audiologists to know more."></meta>
    </Helmet>
      <Header />
      <section class="hearing_service Blogs">
        <div class="container">
          <h1 class="Heading_text">Blogs</h1>
        </div>
      </section>
      <section className="blog_post">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog11} class="card-img-top" alt="..." />
                <div className="date_text">JUNE 23, 2022</div>
                <div class="card-body">
                  <h5 class="card-title">7 Common Myths About Hearing Aids</h5>
                  <p class="card-text">
                    7 Common Myths About Hearing Aids Hearing Aids are
                    sophisticated electronic devices that a person with hearing
                    loss can use to help them hear better again. But the
                    decision to purchase and use one is often met with
                    resistance because of misinformation. In this blog article,
                    we will be debunking 7 of the most common
                  </p>

                  <ul>
                    <li>
                      <a href="#">GENERAL</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog12} class="card-img-top" alt="..." />
                <div className="date_text">MARCH 18, 2021</div>
                <div class="card-body">
                  <h5 class="card-title">
                    Hearing Aid: How To Choose The Right One
                  </h5>
                  <p class="card-text">
                    MARCH 18, 2021 Hearing Aid: How To Choose The Right One
                    Hearing Aid: How To Choose The Right One Hearing Loss &
                    Hearing Aid Hearing impairment commonly occurs due to aging
                    or exposure to loud noises, whereby nerve cells in the
                    cochlea fail to send sound signals to the brain. Other than
                    this, there are diseases, such as Meningitis, Mumps, and
                    Chickenpox that result in hearing loss. Undoubtedly, hearing
                    loss can make life detrimental
                  </p>

                  <ul>
                    <li>
                      <a href="#">GENERAL</a>
                    </li>
                    <li>
                      <a href="#">Hearing Aids</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog13} class="card-img-top" alt="..." />
                <div className="date_text">NOVEMBER 2, 2022</div>
                <div class="card-body">
                  <h5 class="card-title">
                    Best Hearing Aids and Brands In The Market
                  </h5>
                  <p class="card-text">
                    JUNE 23, 2022 7 Common Myths About Hearing Aids 7 Common
                    Myths About Hearing Aids 7 Common Myths About Hearing Aids
                    Hearing Aids are sophisticated electronic devices that a
                    person with hearing loss can use to help them hear better
                    again. But the decision to purchase and use one is often met
                    with resistance because of misinformation. In this blog
                    article, we will be debunking 7 of the most common Read more
                    GENERAL NOVEMBER 2, 2022 Best Hearing Aids and Brands In The
                    Market Best Hearing Aids and Brands In The Market Best
                    Hearing Aids and Brands In The Market The first hearing aids
                    were designed with one goal in mind - to help people with
                    hearing loss hear better. But today, as technology and new
                    inventions continue to take the world by storm, hearing aids
                    no longer just help people hear better – They also help
                  </p>
                  <ul>
                    <li>
                      <a href="#">Hearing Aids</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog13} class="card-img-top" alt="..." />
                <div className="date_text">FEBRUARY 25, 2022</div>
                <div class="card-body">
                  <h5 class="card-title">
                    Hearing Aids – Commonly Asked Questions
                  </h5>
                  <p class="card-text">
                    Hearing Aids – Commonly asked questions Hearing aids are
                    important gadgets for any person suffering from hearing
                    loss. They can not only help to enhance one’s appreciation
                    of sounds around them, they also help to reduce the risk
                    undesirable health conditions like depression and dementia.
                    In this article, we discuss some of the most common
                  </p>

                  <ul>
                    <li>
                      <a href="#">Hearing Aids</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog14} class="card-img-top" alt="..." />
                <div className="date_text">SEPTEMBER 23, 2022</div>
                <div class="card-body">
                  <h5 class="card-title">Best Hearing Aids of 2021</h5>
                  <p class="card-text">
                    Why These Are The Best Hearing Aids Of 2021 Hearing loss is
                    a condition that is becoming more common across the globe,
                    affecting one in eight individuals aged 12 years or older,
                    based on research conducted in the United States. Hearing
                    aids are often prescribed as a treatment for people with
                    hearing impairment. Although hearing
                  </p>

                  <ul>
                    <li>
                      <a href="#">GENERAL</a>
                    </li>
                    <li>
                      <a href="#">Hearing Aids</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog15} class="card-img-top" alt="..." />
                <div className="date_text">SEPTEMBER 22, 2021</div>
                <div class="card-body">
                  <h5 class="card-title">
                    Hearing Aids by The Hearing Centre Singapore
                  </h5>
                  <p class="card-text">
                    Hearing Aid Guide A hearing aid is a small electronic device
                    that helps those with hearing loss and the partially deaf
                    hear more clearly by amplifying sound waves. If you are
                    experiencing hearing loss such that you have difficulty
                    picking up moderate noises, such as a normal conversation,
                    it might be time to consider a
                  </p>

                  <ul>
                    <li>
                      <a href="#">GENERAL</a>
                    </li>
                    <li>
                      <a href="#">Hearing Aids</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4">
              <div class="card">
                <img src={blog16} class="card-img-top" alt="..." />
                <div className="date_text">SEPTEMBER 22, 2021</div>
                <div class="card-body">
                  <h5 class="card-title">Hearing Aids For The Elderly</h5>
                  <p class="card-text">
                    Everything To Know About Hearing Aids For The Elderly As one
                    ages, it is inevitable that their body does not work as well
                    as it used to. Part of this ageing process tends to involve
                    hearing loss in one or both ears. In fact, most people with
                    hearing loss are seniors, and it is common
                  </p>
                  <ul>
                    <li>
                      <a href="#">GENERAL</a>
                    </li>
                    <li>
                      <a href="#">Hearing Aids</a>
                    </li>
                  </ul>
                  <Link to="/Blogs/BlogsView" class="btn btn-primary">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />{" "}
    </>
  );
}
